module.exports = __webpack_public_path__ + "img/9.4bca3359.webp";